import { lazy } from 'react';

export const Layout = lazy(() => import('./layout'));

export const Page = lazy(() => import('./page'));

export async function loader(args) {
  const load = await import('./loader');
  return load.default(args);
}
